import { render } from "./NewsCalendar.vue?vue&type=template&id=38aea3fb&scoped=true"
import script from "./NewsCalendar.vue?vue&type=script&lang=js"
export * from "./NewsCalendar.vue?vue&type=script&lang=js"

import "./NewsCalendar.vue?vue&type=style&index=0&id=38aea3fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38aea3fb"

export default script